<template>
    <v-ons-list-item
            v-bind:modifier="product.variants.length > 0 || product.modifier_sets.length > 0 ? 'chevron' : ''"
            v-bind:class="{ 'product-unavailable': product.is_available == false }"
            class="list-item-product"
            tappable
            v-on:click="beforeEmit('click', $event)"
            v-on:touchstart="beforeEmit('touchstart', $event)"
            v-on:touchend="beforeEmit('touchend', $event)"
            v-on:touchmove="beforeEmit('touchmove', $event)"
            v-on:mousedown="beforeEmit('mousedown', $event)"
            v-on:mouseup="beforeEmit('mouseup', $event)">
        <div class="left">
            <img class="item-image" v-show="productImage(product.product_id)" v-bind:src="productImage(product.product_id)">
            <div class="item-image-empty" v-show="productImage(product.product_id) == null"
                 v-bind:style="{ backgroundColor: product.display_colour ? `#${product.display_colour}` : '' }">
                {{ product.product_name.length > 0 ? product.product_name.substring(0, 1).toUpperCase() : '' }}
            </div>
        </div>
        <div class="center">
            <span class="list-item__title">{{ product.product_name }}</span>
            <span class="list-item__subtitle">
                <template v-if="product.is_available">
                    <vue-clamp class="line-breaks" autoresize :max-lines="max_description_lines"
                       data-test-id="txt-description"
                        >{{ product.product_desc }}</vue-clamp>
                    <span v-show="expand_mode" class="link-button link-button-spaced truncate-toggle"
                          v-on:click="toggleTruncate">
                        <template v-if="description_truncated">Show more</template>
                        <template v-else>Show less</template>
                    </span>
                    <span v-show="getBasketQuantity(product.product_id) > 0" class="label-basket">
                        <i class="fa fa-shopping-basket"></i>
                        {{ getBasketQuantity(product.product_id) }} in basket
                    </span>
                </template>
                <template v-else>
                    <span class="product-subtitle-unavailable">Currently unavailable</span>
                </template>
            </span>
        </div>
        <div class="right">
            <div class="list-item-price-container">
                <small class="item-price-text-from" v-if="product.has_upsell">From</small>
                <span class="item-price-text">
                    {{ filters.money(parseFloat(product.selling_price), true, outlet.currency_symbol) }}
                </span>
            </div>
        </div>
    </v-ons-list-item>
</template>

<script>
    import { mapGetters } from 'vuex'
    import VClamp from 'vue-clamp'

    export default {

        name: "product-menu-list-item",

        props: [
            'product',
            'basket',

            // This may be either:
            // true - Description is truncated to X lines
            // false - Description is not truncated
            // 'expand' - Description is truncated to X lines with a toggle to show non-truncated
            'truncate_description',
        ],

        data() {
            return {
                description_truncated: false,
            }
        },

        components: {
            'vue-clamp': VClamp,
        },

        mounted() {

            // Truncate if forced to truncate or in 'expand' mode (which has an initial state of truncated), otherwise
            // show full description
            this.description_truncated = this.truncate_description == true || this.expand_mode
        },

        methods: {

            getBasketQuantity(root_product_id) {
                if (this.basket == null)
                    return 0

                return this.basket.item_quantities[root_product_id]
            },

            toggleTruncate() {

                this.description_truncated = !this.description_truncated
            },

            beforeEmit(event_name, event) {

                // Unsure if anything can go wrong, so wrap
                let continue_emit = true
                try {
                    continue_emit = event.target.classList.contains('truncate-toggle') == false
                } catch (e) { }

                if (continue_emit == false) {
                    return
                }

                this.$emit(event_name, event)
            }
        },

        computed: {

            ...mapGetters([
                'basketInfo',
                'outlet',
                'productImage',
            ]),

            expand_mode() {

                // Return whether we're using 'expand' mode for text truncation. We have no way to tell if the description
                // text will need to be clamped, so set a minimum size before we show the expand toggle button, to
                // prevent showing a toggle that has no purpose. 120 chars was derived from our smallest supported
                // viewport width (375px).
                return this.truncate_description == 'expand'
                    && this.product.product_desc != null
                    && this.product.product_desc.length > 120
            },

            max_description_lines() {
                return this.description_truncated ? 4 : 0
            },
        }
    }
</script>

<style scoped>
    .list-item-price-container {
        display: flex;
        flex-direction: column;
        color: var(--global-goodtill-green);
    }

    .link-button-spaced {
        padding-top: 10px;
        padding-bottom: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/js/components/fragments/product_menu_list_item.vue